import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconLocation, ImageLocation } from 'src/utils/URLUtils';
import { Feature } from '../Feature';
import styles from './ReasonItem.module.scss';
import VideoModal from './VideoModal/VideoModal';
interface ReasonItemProps {
    feature: Feature;
}

export const ReasonItem = ({ feature }: ReasonItemProps) => {
    const { t, i18n } = useTranslation();
    const [showVideoModal, setShowVideoModal] = useState(false);


    return (
        <>
            <div className={styles.reasonItem} onClick={() => setShowVideoModal(true)}>
                <div className={styles.content}>
                    <h3 className={styles.title}>{t(feature.title)}</h3>
                    <p dir={i18n.dir()} className={styles.description}>{t(feature.description)}</p>
                    <div className={styles.learnMore} >
                        <span className={styles.learnMoreText}>{t('Learn more')}</span>
                        <img
                            src={IconLocation('play-circle')}
                            alt={t(feature.title)}
                            className={styles.icon}
                        />
                    </div>
                </div>
                <img
                    src={ImageLocation(feature.icon)}
                    alt={t(feature.title)}
                    className={styles.logo}
                />
            </div>
            <VideoModal feature={feature}
                isModalOpen={showVideoModal}
                setIsModalOpen={setShowVideoModal} />
        </>
    );
}; 